/** Entrada do lote: as notas selecionadas ou todas as aguardando transmissão (sem seleção). */
export class TransmitirLoteNotaFiscalSaidaDialogData {
  listaIdNFeSaida: number[];
  isTodasAguardandoTransmissao: boolean;
}

/** "Corrigir" de uma nota não enviada: a listagem abre a nota. Nulo ao fechar. */
export class TransmitirLoteNotaFiscalSaidaDialogResult {
  idNFeSaidaCorrigir: number | null;
}
